export enum InterviewSectionDialogAction {
    Saved = 'saved',
    Canceled = 'canceled',
}